const SUBITO_IMAGE_SIZE_MODIFIER_PARAM = "rule";
const SUBITO_DOMAIN = "images.sbito.it";
const AUTO_SCOUT_DOMAIN = "autoscout24.net";
const IMAGE_SIZE_PATTERN = /\/\d+x\d+(\.(jpg|jpeg|png|gif|bmp|webp|tiff|svg))/;

export function updateImageUrl(url: string, subitoRuleValue: string = "gallery-desktop-2x-auto"): string {
  if (url.includes(SUBITO_DOMAIN)) {
    const imageUrl = new URL(url);
    imageUrl.searchParams.set(SUBITO_IMAGE_SIZE_MODIFIER_PARAM, subitoRuleValue);
    return imageUrl.toString();
  }

  if (url.includes(AUTO_SCOUT_DOMAIN)) {
    return url.replace(IMAGE_SIZE_PATTERN, "");
  }

  return url;
}
